import { render, staticRenderFns } from "./OrganizationUserCreate.vue?vue&type=template&id=8bf1a150&"
import script from "./OrganizationUserCreate.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports